import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiPlay, FiArrowRight, FiCheckCircle } = FiIcons;

const QuizCTA = () => {
  const benefits = [
    "Identify your specific executive function challenges",
    "Get personalized recommendations for your recovery",
    "Understand how your brain works (and how to work with it)",
    "Discover if EF therapy is right for you"
  ];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 bg-gradient-to-r from-accent-magenta to-accent-purple">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-white"
          >
            <h2 className="text-3xl lg:text-5xl font-playfair font-bold mb-6">
              Not Sure Where to Start?
            </h2>
            <p className="text-xl mb-8 leading-relaxed opacity-90">
              Take our free Executive Function Assessment to discover your cognitive strengths and challenges. Get personalized insights in just 5 minutes.
            </p>

            <div className="space-y-4 mb-8">
              {benefits.map((benefit, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  viewport={{ once: true }}
                  className="flex items-center gap-3"
                >
                  <SafeIcon icon={FiCheckCircle} className="w-6 h-6 text-accent-gold flex-shrink-0" />
                  <span className="text-lg">{benefit}</span>
                </motion.div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <motion.a
                href="https://www.wethebillions.com/quiz"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="bg-white text-accent-magenta px-8 py-4 rounded-full font-semibold text-lg flex items-center justify-center gap-2 hover:bg-gray-100 transition-colors duration-200"
              >
                Take the FREE Quiz
                <SafeIcon icon={FiPlay} className="w-5 h-5" />
              </motion.a>

              <motion.button
                onClick={() => scrollToSection('contact')}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="border-2 border-white text-white px-8 py-4 rounded-full font-semibold text-lg flex items-center justify-center gap-2 hover:bg-white hover:text-accent-magenta transition-all duration-200"
              >
                Book Consultation
                <SafeIcon icon={FiArrowRight} className="w-5 h-5" />
              </motion.button>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-8 border border-white/20">
              <div className="text-center">
                <div className="w-24 h-24 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6">
                  <SafeIcon icon={FiPlay} className="w-12 h-12 text-white" />
                </div>
                <h3 className="text-2xl font-playfair font-bold text-white mb-4">
                  5-Minute Assessment
                </h3>
                <p className="text-white/80 mb-6">
                  Quick, confidential, and scientifically-backed assessment to understand your executive function profile.
                </p>
                <div className="bg-white/10 rounded-2xl p-4">
                  <p className="text-white font-semibold">
                    Join 2,000+ people who've discovered their EF strengths
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default QuizCTA;